import React from "react";
import { SwitchComponent } from "@syncfusion/ej2-react-buttons";
import { useTranslation } from "react-i18next";

type SwitchButtonProps = {
  switchChecked: boolean;
  setSwitchChecked: (checked: boolean) => void;
  isSendInvitationEnabled: boolean;
};

export const SwitchButton = ({
  switchChecked,
  setSwitchChecked,
  isSendInvitationEnabled,
}: SwitchButtonProps) => {
  const { t } = useTranslation();

  return (
    <div className="button__switch" data-testid="add-user-form-switch-btn">
      <span className="label">
        {t("userManagementPage.sendInvitation_btn", { count: 1 })}
      </span>
      <SwitchComponent
        id="switch"
        data-testid="switch-send-invitation"
        enableRtl={true}
        disabled={!isSendInvitationEnabled}
        checked={switchChecked}
        cssClass="switch"
        onChange={() => setSwitchChecked(!switchChecked)}
      />
    </div>
  );
};
